import { actions, mutations } from "@/constants/state";
import {
  getPendingShiftRequests,
  getShiftRequestsHistory,
  updateAction,
} from "@/services/shift-request-service";

export default {
  [actions.SHIFT_REQUESTS_FETCH_PENDING_ACTION]: async ({ commit }) => {
    const { data } = await getPendingShiftRequests();

    commit(mutations.SHIFT_REQUESTS_FETCH_PENDING_MUTATION, data);
  },
  [actions.SHIFT_REQUESTS_FETCH_HISTORY_ACTION]: async (
    { commit },
    payload
  ) => {
    const { data } = await getShiftRequestsHistory(payload);

    commit(mutations.SHIFT_REQUESTS_FETCH_HISTORY_MUTATION, data);
  },
  [actions.SHIFT_REQUESTS_UPDATE_ACTION]: async (
    { commit },
    { id, action }
  ) => {
    await updateAction(id, action);

    commit(mutations.SHIFT_REQUESTS_REMOVE_REQUEST_MUTATION, id);
  },
};
